<template>
  <Grid gaf="column" justify-content="space-between" align-items="center" class="opaque-header q-pl-xl q-pr-lg q-py-sm">
    <div class="text-subtitle-2 text-secondary-2">
      Product list view
      <HelpPageBtn :page="__guide.productPage" />
    </div>

    <Grid gaf="column" gap="var(--r-space-md)" align-items="center">
      <ExportBtn :loading="exportLoading" @click="$emit('export')" />

      <RBtn size="small" type="tertiary" @click="$emit('create-new-product')">
        create new product
      </RBtn>

      <ShowHideCols :ag-grid="agGrid" />
    </Grid>
  </Grid>
</template>

<script>
// Libraries
import { mapState } from 'vuex'
// Components
import ShowHideCols from '@/ag-grid/components/show-hide-cols/ShowHideCols'
import HelpPageBtn from '@/reusable/base-components/HelpPageBtn'
import ExportBtn from '@/reusable/ExportBtn'

export default {
  components: {
    ShowHideCols,
    HelpPageBtn,
    ExportBtn
  },

  props: {
    agGrid: Object
  },

  computed: {
    ...mapState('lv-products', ['exportLoading'])
  }
}
</script>
